import * as selfConstants from './constants'
import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case selfConstants.SELECT_CHANNEL_INDEX: {
      return {
        ...state,
        selectedChannelIndex: action.payload
      }
    }
    default:
      return state
  }
}
export default reducer
